/**
 * The tablet breakpoint as a media query, for markup that must be right at
 * every width before JavaScript runs (a prerendered page): a <picture>
 * source and a stylesheet can read it, a hook cannot. The same 768 as
 * useIsTabletUp. BELOW_TABLET is its exact complement (no 767.98 gap).
 */
export const TABLET_UP_MEDIA = '(min-width: 768px)';
export const BELOW_TABLET_MEDIA = 'not all and (min-width: 768px)';

/**
 * A 1x1 transparent GIF. As the srcset of a <picture> source whose media
 * matches where the image is hidden, it lets that width skip the download
 * (a data URI is not a request), where display:none alone would not.
 */
export const BLANK_IMAGE =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/**
 * Where the group Empathy tab's sheets (RequestEmpathySheet, BookingSheet)
 * stop being the whole screen and become a Card over a scrim: cohorts.css's
 * `@media (min-width: 640px)` around .ee-cohort-sheet. useScrimClose reads
 * it, so a click beside the panel closes only where there is a scrim.
 */
export const SHEET_SCRIM_MEDIA = '(min-width: 640px)';
